import React from 'react';
import {
    DesktopOnlyItemWrapper,
    IconBadge,
    IconLink,
    MenuIconWrapper,
    MenuLabel,
    StyledMoodBoardIcon,
} from './IconsButtonTray.styles';
import { IdsDropdownMenu } from './IdsDropdownMenu';
import useTranslator from 'Client/hooks/useTranslator';
import useConfig from 'Client/hooks/useConfig';
import useGa from 'Client/hooks/useGa';
import { TrackHeaderActions } from 'Common/ga/types';
import { usePageResolver } from 'Client/components/ListingPage/hooks/useTrackingPageLabel';
import useFeatureToggle from 'Client/hooks/useFeatureToggle';
import paths from 'Common/routes/paths';
import { ensureEndingSlash } from 'Client/urlService';
import { useBellaDispatch, useBellaSelector } from 'Client/redux/hooks';
import { fetchIdsDropdownData } from 'Client/redux/idsDropdown/actions';
import { hideOverlay, showOverlay } from 'Client/redux/header/overlays/actions';
import { OverlayId } from 'Client/components/Overlays/types';
import ContentOverlay from 'Client/components/Overlays/ContentOverlay';

export const MoodBoardMenuItem = () => {
    const t = useTranslator();
    const { links } = useConfig();
    const pageTypeLabel = usePageResolver();
    const { interiorServiceInNav, p100IdsHeaderDropdown } = useFeatureToggle();
    const ga = useGa();
    const dispatch = useBellaDispatch();
    const idsDropdown = useBellaSelector(state => state.header.idsDropdown);

    const menuItem = interiorServiceInNav
        ? {
              label: 'Icon IDS',
              link: ensureEndingSlash(paths.INTERIOR_DESIGN_SERVICE),
              trackingEvent: 'interiordesignclick',
              trackingAction: TrackHeaderActions.HeaderInteriorDesignIconClick,
          }
        : {
              label: 'moodboard_desktopheader',
              link: links.moodboardLandingPage,
              trackingEvent: 'moodboardiconclick',
              trackingAction: TrackHeaderActions.HeaderMoodboardIconClick,
          };

    const handleMenuClick = () => {
        ga.oneHeader.trackHeaderAction(menuItem.trackingEvent, menuItem.trackingAction, pageTypeLabel);
    };

    const iconBadgeText = t('IDS_NEW_icon').toUpperCase();

    const handleMenuActivation = () => {
        if (interiorServiceInNav && p100IdsHeaderDropdown && !idsDropdown?.isFetching && !idsDropdown?.isFetched) {
            dispatch(fetchIdsDropdownData());
        }
        if (interiorServiceInNav && p100IdsHeaderDropdown) {
            dispatch(showOverlay(OverlayId.IDS_DROPDOWN));
        }
    };

    const handleMenuExit = () => {
        if (interiorServiceInNav && p100IdsHeaderDropdown) {
            dispatch(hideOverlay(OverlayId.IDS_DROPDOWN));
        }
    };

    return (
        <DesktopOnlyItemWrapper
            data-testid="one-header-icon-moodboard"
            onClick={handleMenuClick}
            onMouseEnter={handleMenuActivation}
            onMouseLeave={handleMenuExit}
        >
            <IconLink to={menuItem.link}>
                <MenuIconWrapper>
                    {interiorServiceInNav && <IconBadge>{iconBadgeText}</IconBadge>}
                    <StyledMoodBoardIcon />
                </MenuIconWrapper>
                <MenuLabel>{t(menuItem.label)}</MenuLabel>
            </IconLink>
            {p100IdsHeaderDropdown && (
                <ContentOverlay propagateOutsideClicks identifier={OverlayId.IDS_DROPDOWN}>
                    <IdsDropdownMenu />
                </ContentOverlay>
            )}
        </DesktopOnlyItemWrapper>
    );
};
